(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/racing-game/components/play/assets/javascripts/coupon/quinella-odds.js') >= 0) return;  svs.modules.push('/modules/racing-game/components/play/assets/javascripts/coupon/quinella-odds.js');

'use strict';

const {
  useState,
  useCallback
} = React;
const {
  buildQuinellaOddsLookupKey
} = svs.racing.common.strings;
const {
  ReactIcon
} = svs.ui;
const isDesktop = svs.core.detect.formfactor.desktop();
const {
  SwipeArrows
} = svs.sport.swipeArrows;
const {
  getCancelledParticipants
} = svs.racing.common.util;
const renderHeader = (content, cancelledParticipant) => React.createElement("th", {
  className: "quinella-odds-header-item ".concat(cancelledParticipant ? ' cancelled' : ''),
  scope: "col"
}, content);
const renderVerticalHeader = (content, isSquare, cancelledParticipant) => React.createElement("th", {
  className: "quinella-odds-vertical-header-item".concat(isSquare ? ' square' : '', " ").concat(cancelledParticipant ? ' cancelled' : ''),
  scope: "row"
}, content);
const renderCell = (key, content, showMinOdds, cancelledParticipant) => React.createElement("td", {
  className: "quinella-odds-row-item ".concat(cancelledParticipant ? 'cancelled' : ''),
  key: key
}, showMinOdds ? React.createElement("div", {
  className: "u-flex"
}, React.createElement("span", null, React.createElement(ReactIcon, {
  color: "fc-racing",
  icon: "most-played",
  size: "200"
}), "\xA0"), content) : content);
const renderOddsTable = (quinellaOdds, numberOfParticipants, canceledParticipants) => {
  const columnHeaderTitles = [];
  const rows = [];
  const arr = Object.values(quinellaOdds.oddsLookup).filter(value => value && value > 0.0);
  const minOdds = Math.min(...arr);
  for (let y = 0; y < numberOfParticipants; y++) {
    const rowItems = [];
    let cancelledParticipant = false;
    for (let x = 0; x < numberOfParticipants; x++) {
      const lookupKey = buildQuinellaOddsLookupKey(x + 1, y + 1);
      const odds = quinellaOdds.oddsLookup[lookupKey];
      let content = '-';
      let showMinOdds = false;
      const isTopRight = x >= y;

      cancelledParticipant = false;
      if (canceledParticipants.indexOf(x + 1) >= 0 || canceledParticipants.indexOf(y + 1) >= 0) {
        cancelledParticipant = true;
        content = 'STR';
      } else if (odds && odds > 0.0) {
        if (isTopRight) {
          const alternativeLookupKey = buildQuinellaOddsLookupKey(y + 1, x + 1);
          const alternativeOdds = quinellaOdds.oddsLookup[alternativeLookupKey];
          if (alternativeOdds !== odds) {
            content = odds.toFixed(2);
            showMinOdds = Boolean(odds && odds > 0.0 && odds <= minOdds);
          } else {
            content = ' ';
          }
        } else {
          content = odds.toFixed(2);
          showMinOdds = Boolean(odds && odds > 0.0 && odds <= minOdds);
        }
      } else if (isTopRight) {
        content = '';
      }

      rowItems.push(renderCell(lookupKey, content, showMinOdds, cancelledParticipant));
    }

    columnHeaderTitles.push(renderHeader(y + 1, cancelledParticipant));

    rows.push(React.createElement("tr", null, renderVerticalHeader(y + 1, false, cancelledParticipant), rowItems));
  }
  return React.createElement("table", {
    cellPadding: "0",
    cellSpacing: "0",
    className: "quinella-odds-table"
  }, React.createElement("thead", null, React.createElement("tr", null, renderVerticalHeader('Häst', true), columnHeaderTitles)), React.createElement("tbody", null, rows));
};
const getLeftScroll = () => {
  const contentHolder = document.querySelector('.quinella-odds-holder');
  return contentHolder.scrollLeft - contentHolder.clientWidth;
};
const getRightScroll = () => {
  const contentHolder = document.querySelector('.quinella-odds-holder');
  const clientWidth = contentHolder.clientWidth;

  const leftSideHeaderWidth = 49;

  const oddsCellWidth = 84;

  const scrollWidth = clientWidth - leftSideHeaderWidth;

  const numberOfCells = Math.floor(scrollWidth / oddsCellWidth);
  return contentHolder.scrollLeft + numberOfCells * oddsCellWidth;
};
const QuinellaOdds = _ref => {
  let {
    quinellaOdds,
    participants,
    numberOfParticipants
  } = _ref;
  const [tableEl, setTableEl] = useState(null);
  const canceledParticipants = getCancelledParticipants(participants);
  const tableRef = useCallback(node => {
    if (node !== null) {
      setTableEl(node);
    }
  }, []);
  return React.createElement("div", {
    className: "quinella-odds"
  }, React.createElement("div", {
    className: "coupon-stats-header"
  }, React.createElement("div", {
    className: "coupon-stats-header-text"
  }, "Odds f\xF6r alla kombinationer"), React.createElement("div", {
    className: "coupon-stats-header-time"
  }, React.createElement("i", {
    className: "icon-default icon-clock-simple"
  }), React.createElement("span", null, quinellaOdds.time)), canceledParticipants.length > 0 && React.createElement("div", {
    className: "coupon-stats-header-cancelled-participants"
  }, "Oddsen har p\xE5verkats av en eller flera strykningar. Oddsen p\xE5 \xF6vre h\xF6gra halvan visar de kombinationer d\xE4r det nu finns avvikelser.")), isDesktop && React.createElement(SwipeArrows, {
    getLeftScrollWidth: getLeftScroll,
    getRightScrollWidth: getRightScroll,
    scrollContentEl: tableEl,
    scrollParentSelector: "#left-column"
  }), React.createElement("div", {
    className: "quinella-odds-holder",
    ref: tableRef
  }, renderOddsTable(quinellaOdds, numberOfParticipants, canceledParticipants)));
};
svs.racing_game.components.play.QuinellaOdds = QuinellaOdds;

 })(window);